import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";

export class AtgardNaturvardesbedomningCommandBase extends BasicCommand<AtgardNaturvardesbedomningCommandBase> {
    readonly atgardGuid: string;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Naturvardesbedomning";

    get primaryKey(): AtgardNaturvardesbedomningPrimaryKey {
        return {
            atgardGuid: this.atgardGuid
        };
    }

    constructor(atgardGuid: string, typeName: string, commandType: CommandType) {
        super(typeName, AtgardNaturvardesbedomningCommandBase.$groupKey, commandType);
        this.atgardGuid = atgardGuid;
    }
}

export interface AtgardNaturvardesbedomningPrimaryKey extends IPrimaryKey<AtgardNaturvardesbedomningPrimaryKey>{
    atgardGuid: string;
}
